<article class="call2action-initiative-card card bg-primary text-light">
  <div class="col-4 col-sm-5 mb-0">
    <figure class="call2action-initiative-card__figure">
      <h1 class="h2 call2action-initiative-card__title">{{ title || ('initiatief-aanmelden-titel' | fromDictionary) }}</h1>
    </figure>
  </div>
  <main class="col-8 col-sm-7 ps-md-7 ps-sm-5 call2action-initiative-card__main">
    <h2 class="fw-bold font-secondary call2action-initiative-card__subtitle h5 text-max-width mb-3 mb-sm-4">
      {{ subtitle || ('initiatief-aanmelden-subtitel' | fromDictionary) }}
    </h2>
    <a [routerLink]="['/initiatieven/aanmelden']" class="button button--tertiary">
      {{ 'initiatief-aanmelden-knop-tekst' | fromDictionary }}
    </a>
  </main>
</article>
